var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__member-child-selector" }, [
    _c(
      "div",
      {
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleChildMemberSelector($event)
          }
        }
      },
      [
        _c(
          "h1",
          { staticClass: "member-child-selector__name header__member-name" },
          [_vm._v(_vm._s(_vm.decode(_vm.memberName)))]
        ),
        _vm._v(" "),
        _vm._m(0)
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "member-child-selector__child-list",
        class: { "member-child-selector__child-list--active": _vm.isListActive }
      },
      _vm._l(_vm.children, function(child, index) {
        return _c("ChildOption", {
          key: index,
          attrs: { member: child },
          on: { selection: _vm.hideList }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "member-child-selector__indicator" }, [
      _c("i", { staticClass: "fa fa-chevron-down" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }